module.exports = __webpack_public_path__ + "c9783ceb2a.woff2";